import {Component, Input} from '@angular/core';
import {SistemaService} from '../../Servicios/Sistema.Service';
import {TipoIconoEnum} from '../../Enumeraciones/Enumeraciones.enum';

@Component(
  {
    selector: 'icono',
    templateUrl: './Icono.template.html',
    styleUrls: ['./Icono.scss'],
  })

export class IconoComponent
{
  @Input() tipoIcono : TipoIconoEnum = TipoIconoEnum.AweSomeFont;
  @Input() icono : string = "";

  TipoIconoEnum = TipoIconoEnum;

  constructor(public sistemaService : SistemaService)
  {
  }

  ngOnInit()
  {
  }

  SetDatos(icono : any, tipoIcono : TipoIconoEnum)
  {
    this.icono = icono;
    this.tipoIcono = tipoIcono;
  }
}
